import type React from "react";
import { Box, Typography, Container } from "@mui/material";
import testimonialpatterns from "../../../assets/testimonials-white.png";

const services = [
  {
    label: "AI Portrait of Loved One displayed on an easel",
    price: "$20",
  },
  {
    label: "Slideshow with up to 120 photos (8–10 minutes long)",
    price: "$60",
  },
  {
    label: "4 Page Order of Service – 50 printed copies",
    price: "$50",
  },
  {
    label: "100 printed copies",
    price: "$100",
    indent: true,
  },
  {
    label: "Recorded copy of the Livestream on a Flash Stick",
    price: "$25",
  },
  {
    label: "Memory Book",
    price: "$120",
  },
];

const AdditionalServicesPage: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundImage: `url(${testimonialpatterns})`,
        backgroundRepeat: "repeat",
        backgroundPosition: "top center",
        backgroundSize: "auto",
        py: 25,
        px: 5,
      }}
    >
      <Container maxWidth="md">
        {/* Header */}
        <Typography
          align="center"
          sx={{
            fontSize: 18,
            letterSpacing: 1,
            mb: 1,
          }}
        >
          Top 5 Frequently Requested
        </Typography>

        <Typography
          align="center"
          sx={{
            fontSize: 44,
            fontWeight: 500,
            mb: 6,
          }}
        >
          Additional Services
        </Typography>

        {/* Services Card */}
        <Box
          sx={{
            backgroundColor: "#b7ddfb",
            borderRadius: 6,
            px: { xs: 3, md: 3 },
            py: 2,
          }}
        >
          {services.map((service, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 3,
                pl: service.indent ? 3 : 0,
              }}
            >
              {/* Bullet + Text */}
              <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
                {!service.indent && (
                  <Typography sx={{ fontSize: 20, lineHeight: 1 }}>
                    •
                  </Typography>
                )}
                <Typography sx={{ lineHeight: 1.6 }}>
                  {service.label}
                </Typography>
              </Box>

              {/* Price Pill */}
              <Box
                sx={{
                  minWidth: 56,
                  height: 56,
                  borderRadius: "50%",
                  backgroundColor: "#ffffff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 600,
                }}
              >
                {service.price}
              </Box>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default AdditionalServicesPage;
